export class Admission {

  constructor(
    public admissionLevel,
    public admissionType,
    public admissionYear,
    public countyName,
    public description,
    public federal,
    public firstLevelOffender,
    public probationCompleted,
    public probationStatus,
    public prohibited,
    public prohibitedState,
    public question,
    public stateCode,
    public type) { }

  static getAdmissions(specialInstruction: any): string {
    let admission = '';
    for (const admissions of specialInstruction) {
      if (admissions.applicantAdmissions.length > 0) {
        for (const item of admissions.applicantAdmissions) {
          if (item.admissionType !== undefined && item.admissionType !== null && item.admissionType !== '') {
            admission += `\n Admission Type = ${item.admissionType} \n`;

            if (item.question !== '' && item.question !== undefined && item.question !== null) {
              admission += `  Question = ${item.question} \n`;
            }
            if (item.federal !== '' && item.federal !== undefined && item.federal !== null) {
              admission += `  Federal = ${item.federal} \n`;
            }
            if (item.admissionYear !== '' && item.admissionYear !== undefined && item.admissionYear !== null) {
              admission += `  Admission Year = ${item.admissionYear} \n`;
            }
            if (item.stateCode !== '' && item.stateCode !== undefined && item.stateCode !== null) {
              admission += `  State Code = ${item.stateCode} \n`;
            }
            if (item.countyName !== '' && item.countyName !== undefined && item.countyName !== null) {
              admission += `  County Name = ${item.countyName} \n`;
            }
            if (item.description !== '' && item.description !== undefined && item.description !== null) {
              admission += `  Description = ${item.description} \n`;
            }
            if (item.type !== '' && item.type !== undefined && item.type !== null) {
              admission += `  Type = ${item.type} \n`;
            }
            if (item.firstLevelOffender !== '' && item.firstLevelOffender !== undefined && item.firstLevelOffender !== null) {
              admission += `  First Level Offender = ${item.firstLevelOffender} \n`;
            }
            if (item.admissionLevel !== '' && item.admissionLevel !== undefined && item.admissionLevel !== null) {
              admission += `  Admission Level = ${item.admissionLevel} \n`;
            }
            if (item.probationStatus !== '' && item.probationStatus !== undefined && item.probationStatus !== null) {
              admission += `  Probation Status = ${item.probationStatus} \n`;
            }
            if (item.probationCompleted !== '' && item.probationCompleted !== undefined && item.probationCompleted !== null) {
              admission += `  Probation Completed = ${item.probationCompleted} \n`;
            }
            if (item.prohibited !== '' && item.prohibited !== undefined && item.prohibited !== null) {
              admission += `  Prohibited = ${item.prohibited} \n`;
            }
            if (item.prohibitedState !== '' && item.prohibitedState !== undefined && item.prohibitedState !== null) {
              admission += `  Prohibited State = ${item.prohibitedState} \n`;
            }
          }
        }
      } else {
        admission = '';
      }
    }
    return admission;
  }
}




// WEBPACK FOOTER //
// ./src/models/Admission.ts